export default {
  inserted() {
    setTimeout(bindDialog, 150);
    setTimeout(bindDialog, 400);
    bindOverlayReset();
  },

  componentUpdated() {
    setTimeout(bindDialog, 150);
    setTimeout(bindDialog, 400);
    bindOverlayReset();
  },
};

function bindDialog() {
  const dialogs = Array.from(document.querySelectorAll(".draggable-dialog"));
  const dialog = dialogs.reverse().find((row) => row.offsetParent !== null);

  if (!dialog) return;

  const header = dialog.querySelector(".dialog-drag-handle");
  if (!header || header.dataset.dragBound === "true") return;

  header.dataset.dragBound = "true";
  header.style.cursor = "move";

  let startX = 0;
  let startY = 0;
  let initialX = 0;
  let initialY = 0;

  header.onmousedown = function (event) {
    if (event.target.closest("button")) return;

    event.preventDefault();
    startX = event.clientX;
    startY = event.clientY;

    const transform = dialog.style.transform || "";
    const match = transform.match(/translate\((-?\d+)px,\s*(-?\d+)px\)/);
    initialX = match ? parseInt(match[1], 10) : 0;
    initialY = match ? parseInt(match[2], 10) : 0;

    document.onmousemove = function (moveEvent) {
      const currentX = initialX + moveEvent.clientX - startX;
      const currentY = initialY + moveEvent.clientY - startY;
      dialog.style.transform = `translate(${currentX}px, ${currentY}px)`;
    };

    document.onmouseup = function () {
      document.onmousemove = null;
      document.onmouseup = null;
    };
  };
}

function bindOverlayReset() {
  if (document.body.dataset.dragOverlayResetBound === "true") return;

  document.body.dataset.dragOverlayResetBound = "true";
  document.addEventListener("click", (event) => {
    if (!event.target.classList.contains("v-overlay__scrim")) return;

    document.querySelectorAll(".draggable-dialog").forEach((dialog) => {
      dialog.style.transform = "";
    });
  });
}
